/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_Uptime_LabelInputs */

const tr_mesafeli_s12_uptime_label = /** @type {(inputs: Mesafeli_S12_Uptime_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erişilebilirlik:`)
};

const en_mesafeli_s12_uptime_label = /** @type {(inputs: Mesafeli_S12_Uptime_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability:`)
};

const de_mesafeli_s12_uptime_label = /** @type {(inputs: Mesafeli_S12_Uptime_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbarkeit:`)
};

const ru_mesafeli_s12_uptime_label = /** @type {(inputs: Mesafeli_S12_Uptime_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступность:`)
};

/**
* | output |
* | --- |
* | "Availability:" |
*
* @param {Mesafeli_S12_Uptime_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_uptime_label = /** @type {((inputs?: Mesafeli_S12_Uptime_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_Uptime_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_uptime_label(inputs)
	if (locale === "de") return de_mesafeli_s12_uptime_label(inputs)
	if (locale === "ru") return ru_mesafeli_s12_uptime_label(inputs)
	return tr_mesafeli_s12_uptime_label(inputs)
});